import React from "react";

const STATS = [
  { label: "Visitors", value: "1,294", icon: "fas fa-users", gradient: "linear-gradient(135deg, #4f46e5, #818cf8)" },
  { label: "Clients", value: "56", icon: "fas fa-handshake", gradient: "linear-gradient(135deg, #16a34a, #4ade80)" },
  { label: "Projects", value: "24", icon: "fas fa-project-diagram", gradient: "linear-gradient(135deg, #d97706, #fbbf24)" },
  { label: "Certifications", value: "12", icon: "fas fa-award", gradient: "linear-gradient(135deg, #e11d48, #fb7185)" },
];

const StatCard = ({ label, value, icon, gradient }) => (
  <div className="col-sm-6 col-md-3">
    <div className="card">
      <div className="card-body d-flex align-items-center" style={{ gap: "16px" }}>
        <div
          style={{
            width: "48px",
            height: "48px",
            borderRadius: "14px",
            background: gradient,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <i className={icon} style={{ color: "#fff", fontSize: "1.15rem" }}></i>
        </div>
        <div>
          <p className="mb-1" style={{ color: "#8a8896", fontSize: "0.8rem", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.04em" }}>
            {label}
          </p>
          <h4 className="mb-0" style={{ fontWeight: 800 }}>{value}</h4>
        </div>
      </div>
    </div>
  </div>
);

const Dashboard = () => {
  return (
    <div className="content-wrapper">
      {/* Page Header */}
      <div className="content-header">
        <div className="container-fluid">
          <div
            className="card"
            style={{
              border: "none",
              background: "linear-gradient(135deg, #4f46e5, #4338ca)",
              color: "#fff",
              marginBottom: "24px",
            }}
          >
            <div className="card-body text-center py-5">
              <h1 className="m-0" style={{ color: "#fff", fontWeight: 700, fontSize: "1.4rem" }}>Welcome to</h1>
              <h2 style={{ color: "#fff", fontWeight: 800, fontSize: "2rem", margin: "6px 0" }}>
                Eazyworld EHS Engineering Private Limited
              </h2>
              <p className="mb-0" style={{ color: "rgba(255,255,255,0.85)" }}>
                Excellence in Engineering • Safety • Sustainability
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Dashboard Content */}
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            {STATS.map((stat) => (
              <StatCard key={stat.label} {...stat} />
            ))}
          </div>

          {/* Extra Welcome Info */}
          <div className="card mt-2">
            <div className="card-body text-center">
              <p className="lead mb-2" style={{ fontWeight: 600 }}>
                Empowering industries with innovative EHS (Environment, Health, Safety) solutions.
              </p>
              <p className="mb-0" style={{ color: "#8a8896" }}>
                Your safety is our priority • Engineering with precision • Building a sustainable future
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Dashboard;
